module.exports = __webpack_public_path__ + "img/Naeem.ef8200e3.png";